import React, { useEffect, useState} from "react";
import { BsX, BsPlus, BsDash } from "react-icons/bs";
import { useAxios } from "../services/useAxios";
import {alert,confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { getCartCookie } from "../services/common";


export default function Product4 (props){
    const { t } = useTranslation();
    const [request] = useAxios();
    const [cnt, setCnt] = useState(Number(props.obj?.goodsQy));
    var cartCookie = getCartCookie()
    const fn_removeCart = async () =>{
        
        const result = await confirm(t(`Message.goods_info_remove_cart_confirm`), {okText : t(`Message.common_yes`) , cancelText : t(`Message.common_no`)});
            if(result){
                console.log("cartCookie",cartCookie)
            const response = await request.post("/app/cart/removeCartGoodsAPI", {
                userId : cartCookie,
                cartSn : props.obj.cartSn
            });
            if(response.data.resultCode === 200){
                console.log(response.data.result);
                props.fetchData()
            }
        }
    }

    const fnPuls = () =>{
        if(cnt < Number(props.obj.sleQy)){
            setCnt(cnt+1)
        }
        
    }

    const fnMinus = () =>{
        if(cnt> 1){
            setCnt(cnt-1)
            
        }
        
    }
    useEffect(() => {

        
        if(props.obj && props.setTotalAmt){

            props.setTotalAmt(
                {
                    goodsOptnSn : props.obj.goodsOptnSn,
                    goodsSn : props.obj.goodsSn,
                    orderQy : cnt,
                    amount : props.obj.sleAmount,
                    amt : cnt * props.obj.sleAmount
                },props.obj.cartSn)
        }
      }, [cnt]);

    if (props.type==='type10') {
        return(
            <div className="prodType10">                
                <div className="imgWr">
                    <img src={props.img} alt="상품"/>
                </div>
                <ul className="infoWr">
                    <li className="dfColG4">
                        <p className="prodName">{props.prodName}</p>
                        <div className="optionWr">
                            <p className="option">{props.option1}</p>
                            <p className="option">{props.option2}</p>
                        </div>
                    </li>
                    <li className="dfcsG20">
                        <p className="disprice">{props.disprice}</p>
                        <p className="left10Dash">{props.qty}</p>
                    </li>
                </ul>
            </div>
        );
    }else if (props.type==='type11') {
        return(
            <div className="prodType11">
                <div className="chkWr">
                <input type="checkbox" id={'select-'+props.obj.orderDetailSn}
                    onChange={(e) => props.handleSingleCheck(e.target.checked, props.obj)}                    
                    checked={props.checkItems.includes(props.obj) ? true : false} />
                    <label htmlFor={'select-'+props.obj.orderDetailSn}></label>
                </div>
                <div className="imgWr">
                    <img src={props.img} alt="상품"/>
                </div>
                <div className="infoWr">
                    <p className="prodName">{props.prodName}</p>
                    <div className="optionWr mt4">
                        <p className="option">{props.option1}</p>
                        <p className="option">{props.option2}</p>
                    </div>
                    <ul className="mileageWr">
                        <li>
                            <p className="lt">{t(`Message.my_order_detail_mileage_info_buying_confirm_save`)}</p>
                            <p className="rc">{t(`Message.my_order_detail_mileage_info_buying_mlg` , {buyMileage : props.mileage1})}</p>
                        </li>
                        <li>
                            <p className="lt">{t(`Message.my_order_detail_mileage_info_review_confirm_save`)}</p>
                            <p className="rc">{t(`Message.my_order_detail_mileage_info_review_mlg` , {accmlValue : props.mileage2})}</p>
                        </li>
                    </ul>
                </div>
            </div>
        )
    } else if (props.type==='type12') {
        return (
            <div className="prodType12">
                <div className="chkWr">
                    <input type="checkbox" id={'select-'+props.obj.cartSn}
                    onChange={(e) => props.handleSingleCheck(e.target.checked, props.obj.cartSn)}                    
                    checked={props.checkItems.includes(props.obj.cartSn) ? true : false} />
                    <label htmlFor={'select-'+props.obj.cartSn}></label>
                </div>
                <div className="cont">
                    <p className="prodName">{props.prodName}</p>
                    <div className="cartProd">
                        <div className="imgWr">
                            <img src={props.img} alt="상품명" />
                        </div>
                        <ul className="stretch">
                            <li className="dfColG4">
                                <div className="optionWr">
                                    <p className="option">{props.option}</p>
                                </div>
                                <div className="dfcsG8">
                                    <p className="disprice">{props.disprice}</p>
                                    <p className="cost">{props.cost}</p>
                                    <p className="percent">{props.percent}</p>
                                </div>
                                <div className="qtyStatusWr mt4">
                                    <span className="tagList">
                                        { props.obj.sleQy > 10 && <p className="cBlue">판매수량</p> }
                                        { props.obj.sleQy <= 10 && <p className="cRed">품절임박</p> }
                                    </span>
                                    <p className="qtyTxt">{props.obj.sleQy}개 남았습니다</p>
                                </div>
                            </li>
                            <li>
                                <div className="pmBtnWr">
                                    <button type="button" className={"minus "+(cnt === 1 ? "disabled":"")} onClick={fnMinus}><BsDash /></button>
                                    <p className="num">{cnt}</p>
                                    <button type="button" className={"plus "+(cnt === props.obj.sleQy ? "disabled":"")} onClick={fnPuls}><BsPlus /></button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="btnWr">
                    <button type="button" className="xBtn" onClick={fn_removeCart} ><BsX /></button>
                </div>
            </div>
        )
    } else if (props.type === 'type13'){
        return(
            <div className="prodType10">
                <div className="chkWr">
                    <input type="checkbox" id={'select-'+props.obj.orderDetailSn}
                    onChange={(e) => props.handleSingleCheck(e.target.checked, props.obj.orderDetailSn)}                    
                    checked={props.checkItems.includes(props.obj.orderDetailSn) ? true : false} />
                    <label htmlFor={'select-'+props.obj.orderDetailSn}></label>
                </div>
                <div className="imgWr">
                    <img src={props.img} alt="상품"/>
                </div>
                <ul className="infoWr">
                    <li className="dfColG4">
                        <p className="prodName">{props.prodName}</p>
                        <div className="optionWr">
                            <p className="option">{props.option1}</p>
                            <p className="option">{props.option2}</p>
                        </div>
                    </li>
                    <li className="dfcsG20">
                        <p className="disprice">{props.disprice}</p>
                        <p className="left10Dash">{props.qty}</p>
                    </li>
                </ul>
            </div>
        );
    }
};